import {Pipe, PipeTransform, ChangeDetectorRef} from "@angular/core";
import {ConfigurationService} from "./configuration.service";
import {Subscription} from "rxjs";

@Pipe({
    name: 'booleanConfig',
    pure: false
})
export class BooleanConfigPipe implements PipeTransform {
    configSpec: string = null;
    value: boolean = null;
    subscription: Subscription;

    constructor(private configurationService: ConfigurationService, private ref: ChangeDetectorRef) {
        this.subscription = configurationService.configurationChanges.subscribe((configSpec: string) => {
            if (configSpec === this.configSpec) {
                this.configSpec = null;
                this.value = null;
                this.ref.markForCheck();
            }
        })
    }

    transform(configSpec: string): boolean {
        if (configSpec !== this.configSpec) {
            this.configSpec = configSpec;
            this.value = null;
            this.configurationService.getBoolean(configSpec).then((value: boolean) => {
                this.value = value;
                this.ref.markForCheck();
            });
        }
        return this.value;
    }

    ngOnDestroy() {
        if(this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
